<template>
  <div ref="createModal" class="modal fade" id="modal-post-mark" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ getTitle() }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="onForceCloseModal"></button>
        </div>
        <div class="modal-body" v-if="isPreShowModalStateEnable()">
          <span v-if="isStep1()">
            <ShopSelect v-if="isShowModal()" ref="shopSelect" :payload="{
              post_id: getPostId(),
            }" @changeVal="changeShop"/>
          </span>
          <span v-if="isStep2()">
            <Category v-if="isShowModal()" ref="category" :payload="categoryPayload" @changeVal="changeCategory"/>
          </span>
          <span v-if="isStep3()">
            <AdditionalSettings v-if="isShowModal()" ref="additionalSettings" :payload="{
              post_id: getPostId(),
              shop_host: getCurrentShopHost()
            }" @changeVal="changeAdditionalSettings"/>
          </span>
          <span v-if="isStep4()">
            <Complete v-if="isShowModal()" ref="complete" :payload="{
              post_id: getPostId(),
              post_status: getPostStatus()
            }"/>
          </span>
          <div class="modal-footer bg-transparent mt-auto p-0 pt-3" v-if="isShowModalFooter()">
            <div class="align-items-center">
              <div class="col"></div>
              <div class="col-auto">
                <div class="justify-content-end">
                  <!--<button class="btn btn-primary ms-auto no-outline me-2" :class="{'disabled': !isActivePrevStep()}" @click="onPrevStep">
                    Назад
                  </button>-->
                  <button class="btn btn-primary ms-auto no-outline" :class="{'disabled': !isActiveNextStep() || isLoadingStep()}" @click="onNextStep">
                    <span v-if="isLoadingStep()" class="spinner-border spinner-border-sm me-2"></span>
                    Далее
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="page-body">
            <div class="container-xl">
              <div class="row">
                <div class="mb-3">
                  <div class="loader-item">
                    <span class="me-2">Идет предподготовка данных...</span>
                    <div class="spinner-border spinner-border-sm me-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {reactive, ref, onMounted, defineComponent, toRaw, watch, computed} from 'vue'
import createParams from "./services/params/create"
import updateParams from "./services/params/update"

import ShopSelect from "./components/shop_select/Index"

import AdditionalSettings from "./components/additional_settings/Index"

import Complete from "./components/complete/Index"

import Category from "./components/category/Index"

import Helper from "@/services/Helper"
import Notify from "@/services/Notify"
import Api from "./services/Api"
import {
  notesTypeId,
  promocodeTypeId,
  salesTypeId,
  offersTypeId,
  freeTypeId,
  foodAndProductsTypeId,
  banksTypeId,
  gamesTypeId,
  raffleTypeId, articlesTypeId
} from "@/modules/post/services/TypeId"
export default defineComponent({
  name: "MarkAdModal",
  components: {
    AdditionalSettings,
    ShopSelect,
    Complete,
    Category,
  },
  setup() {
    const createModal = ref(null);
    const fields = reactive(getFields())

    let bootModal = null
    let params = ref(getParams())

    let forceCloseModal = ref(false)
    let stateCloseModal = ref(true)

    let payload = reactive({
      shopItems: {},
      imageOverlayText: null,
      imageOverlayTextStatus: null,
    })

    let currentStep = ref(1)

    let programCloseModal = ref(false)

    let preShowModalState = ref(false)

    const loadingStep = ref(false)

    const shopSelect = ref(null)
    const additionalSettings = ref(null)
    const category = ref(null)

    const shopsHost = ref([])

    function getParams() {
      return {
        data: {
          title: "",
          page: "",
        }
      }
    }

    function resetParams() {
      params.value = getParams()
    }

    function getFields() {
      return {
        post_id: null,
        post_status: null,
        post_payload: {},
        channel_id: null,
        type_id: null,
      }
    }

    function setStateCloseModal(val) {
      stateCloseModal.value = val
    }

    function getStateCloseModal() {
      return stateCloseModal.value
    }

    function closeModal() {
      clearForm()
      setStateCloseModal(true)
      programCloseModal.value = false
    }

    async function showModal(event) {
      if (!confirm("Пост будет сохранен, продолжить?")) {
        onForceCloseModal()
        event.preventDefault()
        return false
      }

      let isSave = await savePost(event)

      if (isSave === false) {
        onForceCloseModal()
        Notify.error("Ошибка при сохранении поста")
        return false
      }

      const button = event.relatedTarget
      const type = button.getAttribute('data-type')

      setStateCloseModal(false)

      // это оставлено на случай, если пригодится такое условие
      // не стал выпиливать, так как это было уже написано ранее
      if (type === "create") {
        setParams(createParams)
        create(event)
      } else {
        setParams(updateParams)
        update(event)
      }
    }

    function setParams(val) {
      params.value = val
    }

    function create() {}

    function update(event) {
      const button = event.relatedTarget
      const object = JSON.parse(button.getAttribute('data-object'))

      updateFields({
        post_id: object.post_id,
        post_status: object.post_status,
        post_payload: object.post_payload,
        channel_id: object.channel_id,
        type_id: object.type_id,
      })
    }

    function updateFields({post_id, post_status, post_payload, channel_id, type_id}) {
      fields.post_id = post_id
      fields.post_status = post_status
      fields.post_payload = post_payload
      fields.channel_id = channel_id
      fields.type_id = type_id
    }

    async function preShowModal() {
      preShowModalStateDisable()
      resetParams()
      resetPayload()
      resetStep()
    }

    function preShowModalStateEnable() {
      preShowModalState.value = true
    }

    function preShowModalStateDisable() {
      preShowModalState.value = false
    }

    function isPreShowModalStateEnable() {
      return preShowModalState.value === true
    }

    async function savePost(event) {
      const button = event.relatedTarget
      const object = JSON.parse(button.getAttribute('data-object'))

      let result = false

      updateFields({
        post_id: object.post_id,
        post_status: object.post_status,
        post_payload: object.post_payload,
        channel_id: object.channel_id,
        type_id: object.type_id,
      })

      try {
        if (isChannelSite()) {
          if (getTypeId() === salesTypeId) {
            await Api.siteSalesSave(object?.post_payload)
          } else if (getTypeId() === notesTypeId) {
            await Api.siteNotesSave(object?.post_payload)
          } else if (getTypeId() === promocodeTypeId) {
            await Api.sitePromocodeSave(object?.post_payload)
          } else if (getTypeId() === offersTypeId) {
            await Api.siteSalesSave(object?.post_payload)
          } else if (getTypeId() === freeTypeId) {
            await Api.siteSalesSave(object?.post_payload)
          } else if (getTypeId() === foodAndProductsTypeId) {
            await Api.siteSalesSave(object?.post_payload)
          } else if (getTypeId() === banksTypeId) {
            await Api.siteSalesSave(object?.post_payload)
          } else if (getTypeId() === gamesTypeId) {
            await Api.siteSalesSave(object?.post_payload)
          } else if (getTypeId() === raffleTypeId) {
            await Api.siteSalesSave(object?.post_payload)
          } else if (getTypeId() === articlesTypeId) {
            await Api.siteArticlesSave(object?.post_payload)
          } else {
            throw new Error("Неверный тип поста")
          }
        } else {
          await Api.telegramSave(object?.post_payload)
        }

        preShowModalStateEnable()
        result = true
      } catch {
        result = false
      }

      return result
    }

    function resetStep() {
      currentStep.value = 1
    }

    function resetPayload() {
      payload.shopItems = {}
      payload.imageOverlayText = null
      payload.imageOverlayTextStatus = null
    }

    onMounted(() => {
      bootModal = new bootstrap.Modal(createModal.value);
      createModal.value.addEventListener('shown.bs.modal', showModal)
      createModal.value.addEventListener('show.bs.modal', preShowModal)
      createModal.value.addEventListener('hidden.bs.modal', closeModal)
      createModal.value.addEventListener('hide.bs.modal', hideModal)
    })

    watch(() => programCloseModal.value, (newValues) => {
      if (newValues === true) {
        onForceCloseModal()
      }
    })

    function getPayloadShopItems() {
      return payload.shopItems
    }

    function hideModal(event) {
      if (forceCloseModal.value === true) {
        forceCloseModal.value = false
      } else {
        event.preventDefault()
      }
    }

    function onForceCloseModal() {
      forceCloseModal.value = true
      bootModal.hide()
    }

    function clearForm() {
      let items = getFields()

      for (let key of Object.keys(items)) {
        fields[key] = items[key]
      }
    }

    function hasPostId() {
      return fields.post_id !== null
    }

    function getPostId() {
      return fields.post_id
    }

    function getTypeId() {
      return fields.type_id
    }

    function isChannelSite() {
      return fields.channel_id === 1
    }

    function getPostStatus() {
      return fields.post_status
    }

    function getTitle() {
      let result = ""

      if (hasPostId()) {
        result += "Маркировка поста: "
        result += fields.post_id
      }

      return result
    }

    function isShowModal() {
      return getStateCloseModal() === false
    }

    function changeCategory(val) {
      let shopId = val["shop_id"]
      let categoryId = val["category_id"]

      if (payload.shopItems[shopId] === undefined) {
        throw new Error("Неверный магазин")
      }

      payload.shopItems[shopId] = Helper.mergeObject(payload.shopItems[shopId], {
        category_id: categoryId,
      })
    }

    function changeShop(val) {
      payload.shopItems = val["shop_items"]
      payload.shop_type = val["shop_type"]
      programCloseModal.value = val["close_modal"]
    }

    function getShopTypePayload() {
      return payload.shop_type
    }

    function getShopItems() {
      return payload.shopItems
    }

    function changeAdditionalSettings(val) {
      payload.imageOverlayText = val["text"]
      payload.imageOverlayTextStatus = val["status"]
    }

    function getImageOverlayTextPayload() {
      return payload.imageOverlayText
    }

    function getImageOverlayTextStatusPayload() {
      return payload.imageOverlayTextStatus
    }

    function isStep1() {
      return currentStep.value === 1
    }

    function isStep2() {
      return currentStep.value === 2
    }

    function isStep3() {
      return currentStep.value === 3
    }

    function isStep4() {
      return currentStep.value === 4
    }

    async function nextStep() {
      if (isStep1()) {
        enableLoadingStep()

        await shopSelect.value?.startRequest(getPostId()).then(async (resp) => {
          if (resp["show_category"] === true) {
            addCurrentStep(1)
          } else {
            //if (resp["shop_type"] === "one") {
              // todo вызов только чтобы наполнить массив, так быть не должно
              let shops = getShopsForApi()

              // todo это не должно тут быть
              return Api.erid(getPostId(), shops).then(async () => {
                let post = await getPost(getPostId())
                let hasImage = post.item?.has_image

                if (hasImage === undefined) {
                  throw new Error("Отсутствует параметр has_image")
                }

                if (hasImage === 1) {
                  if (resp["shop_type"] === "one") {
                    addCurrentStep(2)
                  } else {
                    addCurrentStep(3)
                  }
                } else {
                  addCurrentStep(3)
                }
              }).finally(() => {
                disableLoadingStep()
              }).catch(() => {
                Notify.error("Ошибка при формировании erid")
              })
            /*} else {
              addCurrentStep(3)
            }*/
          }
        }).finally(() => {
          disableLoadingStep()
        }).catch(() => {
          Notify.error("Ошибка при проверки категории")
        })
      } else if (isStep2()) {
        let shops = getShopsForApi()
        let shopItems = getPayloadShopItems()

        let isSelectCategories = true
        Object.values(shopItems).forEach(value => {
          if (value["category_id"] === undefined || value["category_id"] === null) {
            isSelectCategories = false
          }
        })

        if (isSelectCategories === false) {
          Notify.error("Необходимо выбрать категории/подкатегории")
          return false
        }

        enableLoadingStep()
        await category.value?.startRequest(getPostId(), shops).then(async () => {
          if (getShopTypePayload() === "one") {
            let post = await getPost(getPostId())
            let hasImage = post.item?.has_image

            if (hasImage === undefined) {
              throw new Error("Отсутствует параметр has_image")
            }

            if (hasImage === 1) {
              addCurrentStep(1)
            } else {
              addCurrentStep(2)
            }
          } else if (getShopTypePayload() === "more") {
            addCurrentStep(2)
          } else {
            throw Error("Тип не определен")
          }
        }).finally(() => {
          disableLoadingStep()
        }).catch(() => {
          Notify.error("Ошибка при формировании erid")
        })
      } else if (isStep3()) {
        enableLoadingStep()

        if (getImageOverlayTextStatusPayload() === true && getImageOverlayTextPayload() === "") {
          Notify.error("Необходимо заполнить текст, накладываемый на картинку")
        }

        await additionalSettings.value?.startRequest(getPostId(), getImageOverlayTextPayload(), getImageOverlayTextStatusPayload()).then(() => {
          addCurrentStep(1)
        }).finally(() => {
          disableLoadingStep()
        }).catch(() => {
          Notify.error("Ошибка при сохранении доп. параметров")
        })
      }
    }

    async function getPost(postId) {
      try {
        return await Api.getPost(postId)
      } catch {
        throw Error("Ошибка при получении поста")
      }
    }

    function getShopsForApi() {
      let items = []

      if (getShopTypePayload() === "one") {
        shopsHost.value = []
        Object.values(getShopItems()).forEach((item) => {
          let categoryId = item["category_id"] === undefined ? null : item["category_id"]

          shopsHost.value.push({
            "element": item["shop_host"],
            "category_id": categoryId,
          })
        });
        items = toRaw(shopsHost.value)
      } else if (getShopTypePayload() === "more") {
        let compositeId = []

        Object.values(getShopItems()).forEach((item) => {
          let categoryId = item["category_id"] === undefined ? null : item["category_id"]

          compositeId.push({
            "element": item["composite_id"],
            "category_id": categoryId,
          })
        });
        items = compositeId
      }

      return items
    }

    function getCurrentShopHost() {
      const rawArray = toRaw(shopsHost.value)

      return rawArray[0]["element"]
    }

    function enableLoadingStep() {
      return loadingStep.value = true
    }

    function disableLoadingStep() {
      return loadingStep.value = false
    }

    function addCurrentStep(val) {
      currentStep.value += val
    }

    function prevStep() {
      disableLoadingStep()
      currentStep.value--
    }

    function isActiveNextStep() {
      if (currentStep.value === 1) {
        return Helper.getObjectCount(payload.shopItems) > 0
      } else if (currentStep.value === 2) {
        return true
      } else if (currentStep.value === 3) {
        return payload.imageOverlayTextStatus === false ||
            (payload.imageOverlayTextStatus === true && payload.imageOverlayText !== "")
      }

      return false
    }

    function isActivePrevStep() {
      return currentStep.value > 1
    }

    function onNextStep() {
      nextStep()
    }

    function onPrevStep() {
      prevStep()
    }

    function isLoadingStep() {
      return loadingStep.value === true
    }

    function isShowModalFooter() {
      if (!isStep4()) {
        return true
      }

      return false
    }

    const categoryPayload = computed(() => ({
      post_id: getPostId(),
      shop_items: getShopsForApi(),
      shop_type: getShopTypePayload(),
    }));

    return {
      onForceCloseModal,
      getTitle,
      createModal,
      fields,
      params,
      getPostId,
      getPostStatus,
      isShowModal,
      changeShop,
      changeAdditionalSettings,
      changeCategory,
      isActiveNextStep,
      isActivePrevStep,
      isStep1,
      isStep2,
      isStep3,
      isStep4,
      onNextStep,
      onPrevStep,
      payload,
      shopSelect,
      additionalSettings,
      category,
      isLoadingStep,
      isShowModalFooter,
      getCurrentShopHost,
      getPayloadShopItems,
      getShopsForApi,
      getShopTypePayload,
      categoryPayload,
      isPreShowModalStateEnable,
      getTypeId,
    }
  }
})
</script>
